import React from 'react';
import cx from 'classnames';

import { Subtitle2 } from '../Typography';

import SmartLink from '../SmartLink';

import styles from './index.module.scss';

interface QuickActionCardProps {
  icon: React.ReactNode;
  title: string;
  url: string;
  className: string;
}

const QuickActionCard: React.FC<QuickActionCardProps> = ({
  icon,
  title,
  url,
  className
}) => {
  return (
    <SmartLink to={url} className={styles.wrapper}>
      <div className={styles.content}>
        {icon}
        <Subtitle2 className={styles.title}>{title}</Subtitle2>
        <div
          className={cx(
            {
              [styles.line]: true
            },
            className && { [className]: true }
          )}
        ></div>
        <div
          className={cx(
            {
              [styles.cardShadow]: true
            },
            className && { [className]: true }
          )}
        ></div>
      </div>
    </SmartLink>
  );
};

export default QuickActionCard;
